import React from 'react';
import { Typography } from '@telus-uds/components-web';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { stylePage } from './styles';

const ThankYou = () => {
  const {
    THANK_YOU_PAGE: {
      THANK_YOU,
      MESSAGE
    }
  } = useLocalizedStringsContext();
  return (
    <div style={stylePage}>
      <div id="main">
        <div id="main-wrapper">
          <div id="main-content" style={{ textAlign: 'center' }}>
            <Typography heading="h2" variant={{ size: 'h2' }} block>
              {THANK_YOU}
            </Typography>
            <br />
            <Typography block>
              {MESSAGE}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThankYou;
